export function resetQSToDefault(history, key: string) {
  let mutableQueryString = new URLSearchParams(window.location.search);
  mutableQueryString.delete(key);
  history.push(`?${mutableQueryString.toString()}`);
}
export function updateQSAndApply({ name, value }, history) {
  let mutableQueryString = new URLSearchParams(window.location.search);
  mutableQueryString.set(name, value);
  history.push(`?${mutableQueryString.toString()}`);
}
export function getValueFromQS(key: string) {
  let mutableQueryString = new URLSearchParams(window.location.search);
  return mutableQueryString.get(key);
}
